import { Container, Grid } from '@material-ui/core'
import { HeaderHLPure } from '../../pures'
import BotAdministrationList from './bot-administration-list'

const BotAdministrationView = (props) => {
  const {
    t,
    botList,
    updateBotStatus
  } = props


  return (
    <Container className='view-container'>
      <Grid container spacing={2}>
        <Grid item xs={12} className='header-inbox'>
          <HeaderHLPure title={t('title')} />
        </Grid>
        {
          // Main grid table
          <BotAdministrationList {...props} />
        }
      </Grid>
    </Container>
  )
}

export { BotAdministrationView as default }